<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.branchName')
            }}</label>
            <ts-branch-filter @filter="setBranchList" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.academicYear')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="acYearId"
              :options="acYearOptions"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.mainProgram')
            }}</label>
            <a-select
              style="width: 100%"
              :disabled="!acYearId"
              v-model="acpId"
              :options="mainProgram"
              @change="getTerm"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.academicTerm')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="acTermId"
              :options="termLists"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.scoringCycle')
            }}</label>
            <a-select
              style="width: 100%"
              v-model="cycle"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
            >
              <a-select-option :value="5">{{
                $t('generatetotalscore.unit')
              }}</a-select-option>
              <a-select-option :value="0">{{
                $t('generatetotalscore.termlyScore')
              }}</a-select-option>
              <a-select-option :value="7">{{
                $t('generatetotalscore.termly')
              }}</a-select-option>
              <a-select-option :value="1">{{
                $t('generatetotalscore.monthlyScore')
              }}</a-select-option>
              <a-select-option :value="6">{{
                $t('generatetotalscore.monthlyForSemester')
              }}</a-select-option>
              <a-select-option :value="2">{{
                $t('generatetotalscore.semesterScore')
              }}</a-select-option>
              <a-select-option :value="3">{{
                $t('generatetotalscore.semesterly')
              }}</a-select-option>
              <a-select-option :value="4">{{
                $t('generatetotalscore.yearly')
              }}</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'drawerFilter',
  data() {
    return {
      loading: false,
      acYearOptions: [],
      mainProgram: [],
      termLists: []
    }
  },
  created() {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get() {
        return this.$store.state.generateTotalScore.scoring_cycle_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_SCORING_CYCLE_ID', newValue)
      }
    },
    acYearId: {
      get() {
        return this.$store.state.generateTotalScore.ac_year_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_YEAR_ID', newValue)
      }
    },
    acpId: {
      get() {
        return this.$store.state.generateTotalScore.acp_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_MAIN_PROGRAM', newValue)
      }
    },
    acTermId: {
      get() {
        return this.$store.state.generateTotalScore.ac_term_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_TERM_ID', newValue)
      }
    }
  },
  methods: {
    async fetchAcYear() {
      this.loading = true
      await this.$store
        .dispatch('generateTotalScore/getAcYear')
        .then(response => {
          this.acYearOptions = response.data.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('generateTotalScore/getMainProgram')
        .then(response => {
          this.mainProgram = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranchList(branch) {
      this.$store.commit('generateTotalScore/SET_BRANCH_LIST', branch)
    },
    getTerm() {
      this.loading = true
      this.acTermId = null
      this.$store
        .dispatch('generateTotalScore/getTermByMainProgram', {
          ac_year_id: this.acYearId,
          acp_id: this.acpId
        })
        .then(response => {
          this.termLists = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
